import { createFileRoute } from '@tanstack/react-router';
import { SixSenseMcpCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/sixsense-mcp/callback')({
  component: SixSenseMcpCallbackPage,
});
